{
  "id": "pickled-red-onions",
  "slug": "pickled-red-onions",
  "collectionName": "Pickled Red Onions",
  "title": "Pickled Red Onions Recipes",
  "category": "pickles",
  "subcategory": "condiments",
  "tags": ["pickles", "onions", "condiment", "quick-pickle", "bbq-toppings"],
  "description": "Three delicious pickled red onion recipes: Classic, with Beets, and Poblano-Shallot version. Perfect acidic complement to BBQ, tacos, sandwiches, and salads.",
  "difficulty": "beginner",
  "prepTime": "10 minutes",
  "activeTime": "15 minutes",
  "totalTime": "1 hour 15 minutes",
  "servings": "1 jar (about 2 cups)",
  "author": "Jonny",
  "datePublished": "2022-02-17",
  "featuredImage": "media/tiktok_7359979266332740906.png",
  "gallerySearchTerm": "pickled onions",
  "postEmbedGroupCode": "easy-pickled-red-onions-recipe",
  "blogPostUrl": "/blog/pickled-red-onions",
  "equipment": ["Mason jar", "Saucepan", "Sharp knife", "Cutting board"],
  "variants": [
    {
      "variantId": "classic",
      "name": "Classic Pickled Red Onions",
      "description": "Simple, versatile recipe that works with everything.",
      "featured": true,
      "ingredients": [
        {
          "item": "Water",
          "amount": 1,
          "unit": "cup"
        },
        {
          "item": "Vinegar",
          "amount": 1,
          "unit": "cup",
          "notes": "white, apple cider, or red wine"
        },
        {
          "item": "Kosher Salt",
          "amount": 2,
          "unit": "tsp"
        },
        {
          "item": "Sugar",
          "amount": 3,
          "unit": "tbsp",
          "notes": "or sugar substitute (optional)"
        },
        {
          "item": "Garlic",
          "amount": 2,
          "unit": "cloves",
          "notes": "smashed"
        },
        {
          "item": "Thyme",
          "amount": 4,
          "unit": "sprigs"
        },
        {
          "item": "Black Peppercorns",
          "amount": 10
        },
        {
          "item": "Bay Leaves",
          "amount": 2
        },
        {
          "item": "Red Pepper Flakes",
          "amount": 1,
          "unit": "pinch"
        },
        {
          "item": "Red Onion",
          "amount": 1,
          "unit": "large"
        }
      ]
    },
    {
      "variantId": "with-beets",
      "name": "Pickled Red Onions with Beets",
      "description": "Stunning magenta color from beets. Beautiful and delicious.",
      "ingredients": [
        {
          "item": "Water",
          "amount": 1,
          "unit": "cup"
        },
        {
          "item": "White Vinegar",
          "amount": 1,
          "unit": "cup"
        },
        {
          "item": "Salt",
          "amount": 2,
          "unit": "tsp"
        },
        {
          "item": "Sugar",
          "amount": 3,
          "unit": "tbsp"
        },
        {
          "item": "Raw Beet",
          "amount": 1,
          "unit": "small",
          "notes": "peeled and sliced"
        },
        {
          "item": "Garlic",
          "amount": 2,
          "unit": "cloves"
        },
        {
          "item": "Bay Leaves",
          "amount": 2
        },
        {
          "item": "Black Peppercorns",
          "amount": 8
        },
        {
          "item": "Red Onion",
          "amount": 1,
          "unit": "large"
        }
      ],
      "notes": "Beets turn the onions a beautiful deep magenta color and add subtle earthy sweetness."
    },
    {
      "variantId": "poblano-shallot",
      "name": "Pickled Red Onions with Poblano & Shallots",
      "description": "Apple cider vinegar base with smoked salt and roasted poblanos for complex flavor.",
      "ingredients": [
        {
          "item": "Apple Cider Vinegar",
          "amount": 2,
          "unit": "cups"
        },
        {
          "item": "Water",
          "amount": 1,
          "unit": "cup"
        },
        {
          "item": "Smoked Salt",
          "amount": 3,
          "unit": "tsp",
          "notes": "or kosher salt"
        },
        {
          "item": "Sugar",
          "amount": 3,
          "unit": "tbsp"
        },
        {
          "item": "Red Onion",
          "amount": 2,
          "unit": "medium"
        },
        {
          "item": "Shallots",
          "amount": 3
        },
        {
          "item": "Poblano Peppers",
          "amount": 2,
          "notes": "roasted and sliced"
        },
        {
          "item": "Garlic",
          "amount": 4,
          "unit": "cloves"
        },
        {
          "item": "Bay Leaves",
          "amount": 3
        },
        {
          "item": "Black Peppercorns",
          "amount": 12
        }
      ],
      "notes": "Roast poblanos over flame or under broiler until charred, then peel and slice. Smoked salt adds BBQ flavor."
    }
  ],
  "instructions": [
    {
      "step": 1,
      "title": "Make the brine",
      "description": "Add vinegar, water, salt, and sugar to pot. Stir and bring to boil, then remove from heat immediately.",
      "duration": "5 minutes",
      "tips": ["Don't overboil", "Stir to dissolve salt and sugar completely"]
    },
    {
      "step": 2,
      "title": "Slice the onion",
      "description": "Slice onion pole to pole (root to stem). Cut off stem. Place cut-side down, slice in half through root. Cut off root. Remove papery layers.",
      "tips": [
        "Consistent slices = even pickling",
        "Cut pole-to-pole keeps onions from falling apart"
      ]
    },
    {
      "step": 3,
      "title": "Slice uniformly",
      "description": "Place flat-side down, stem at top, root at bottom. Slice from right to left as uniformly as possible. When near the end, flip on side and continue slicing.",
      "tips": [
        "Aim for 1/8 inch slices",
        "Thinner = quicker pickling",
        "Uniform slices look better"
      ]
    },
    {
      "step": 4,
      "title": "Pack the jar",
      "description": "Put sliced onions in clean jar. Add chosen aromatics and spices between layers.",
      "tips": ["Pack loosely for brine circulation", "If using beets, layer them with onions"]
    },
    {
      "step": 5,
      "title": "Add aromatics",
      "description": "Add garlic (smashed), bay leaves, thyme, peppercorns, red pepper flakes, and any other chosen seasonings to jar.",
      "tips": ["Don't overthink it - experiment!", "Make two jars: one classic, one experiment"]
    },
    {
      "step": 6,
      "title": "Pour the brine",
      "description": "Pour hot pickling liquid into jar over onions until completely covered.",
      "tips": ["Make sure all onions are submerged", "Leave 1/4 inch headspace"]
    },
    {
      "step": 7,
      "title": "Weight down (if needed)",
      "description": "If onions float, place paper towel on top to keep them submerged.",
      "tips": ["Submerged onions pickle evenly", "Can use small plate or jar weight instead"]
    },
    {
      "step": 8,
      "title": "Cool and refrigerate",
      "description": "Put on lid. Let sit at room temperature for 1 hour, then refrigerate.",
      "duration": "1 hour at room temp",
      "tips": ["Can eat immediately", "Flavor improves after 24 hours"]
    },
    {
      "step": 9,
      "title": "Store and enjoy",
      "description": "Keep refrigerated. Will last 2-3 weeks. Use on BBQ, tacos, sandwiches, salads, hot dogs, burgers - anything!",
      "tips": [
        "Mine never last more than a week",
        "Make fresh batches weekly",
        "Liquid can be reused once"
      ]
    }
  ],
  "sharedNotes": "Pickled red onions are endlessly versatile. They add acidity, crunch, and beautiful color to any dish. The basic brine (water, vinegar, salt, sugar) stays the same - feel free to experiment with different spices and additions!",
  "tips": [
    "Make two small jars instead of one large: one classic, one experiment",
    "Try different vinegars: white (sharp), apple cider (mellow), red wine (fruity)",
    "Adjust sweetness to taste - some prefer no sugar",
    "Yellow onions work too, but red onions are prettiest",
    "Add jalapeños for heat",
    "Try different herbs: cilantro stems, oregano, rosemary"
  ],
  "relatedRecipes": ["pickled-carrots"],
  "printMode": {
    "title": "Pickled Red Onions Recipes",
    "servings": "1 jar (about 2 cups)",
    "totalTime": "1 hour 15 minutes",
    "difficulty": "beginner",
    "variants": [
      {
        "variantId": "classic",
        "name": "Classic Pickled Red Onions",
        "ingredients": [
          {
            "item": "Water",
            "amount": 1,
            "unit": "cup"
          },
          {
            "item": "Vinegar (white, apple cider, or red wine)",
            "amount": 1,
            "unit": "cup"
          },
          {
            "item": "Kosher Salt",
            "amount": 2,
            "unit": "tsp"
          },
          {
            "item": "Sugar",
            "amount": 3,
            "unit": "tbsp",
            "notes": "optional"
          },
          {
            "item": "Garlic",
            "amount": 2,
            "unit": "cloves",
            "notes": "smashed"
          },
          {
            "item": "Thyme",
            "amount": 4,
            "unit": "sprigs"
          },
          {
            "item": "Black Peppercorns",
            "amount": 10
          },
          {
            "item": "Bay Leaves",
            "amount": 2
          },
          {
            "item": "Red Pepper Flakes",
            "amount": 1,
            "unit": "pinch"
          },
          {
            "item": "Red Onion",
            "amount": 1,
            "unit": "large"
          }
        ]
      },
      {
        "variantId": "with-beets",
        "name": "With Beets (Magenta Color)",
        "ingredients": [
          {
            "item": "Water",
            "amount": 1,
            "unit": "cup"
          },
          {
            "item": "White Vinegar",
            "amount": 1,
            "unit": "cup"
          },
          {
            "item": "Salt",
            "amount": 2,
            "unit": "tsp"
          },
          {
            "item": "Sugar",
            "amount": 3,
            "unit": "tbsp"
          },
          {
            "item": "Raw Beet",
            "amount": 1,
            "unit": "small",
            "notes": "peeled and sliced"
          },
          {
            "item": "Garlic",
            "amount": 2,
            "unit": "cloves"
          },
          {
            "item": "Bay Leaves",
            "amount": 2
          },
          {
            "item": "Black Peppercorns",
            "amount": 8
          },
          {
            "item": "Red Onion",
            "amount": 1,
            "unit": "large"
          }
        ]
      },
      {
        "variantId": "poblano-shallot",
        "name": "Poblano & Shallots",
        "ingredients": [
          {
            "item": "Apple Cider Vinegar",
            "amount": 2,
            "unit": "cups"
          },
          {
            "item": "Water",
            "amount": 1,
            "unit": "cup"
          },
          {
            "item": "Smoked Salt",
            "amount": 3,
            "unit": "tsp",
            "notes": "or kosher salt"
          },
          {
            "item": "Sugar",
            "amount": 3,
            "unit": "tbsp"
          },
          {
            "item": "Red Onion",
            "amount": 2,
            "unit": "medium"
          },
          {
            "item": "Shallots",
            "amount": 3
          },
          {
            "item": "Poblano Peppers",
            "amount": 2,
            "notes": "roasted and sliced"
          },
          {
            "item": "Garlic",
            "amount": 4,
            "unit": "cloves"
          },
          {
            "item": "Bay Leaves",
            "amount": 3
          },
          {
            "item": "Black Peppercorns",
            "amount": 12
          }
        ]
      }
    ],
    "instructions": [
      "Make brine: Add vinegar, water, salt, and sugar to pot. Stir, bring to boil, remove from heat (5 minutes).",
      "Slice onion pole to pole (root to stem). Cut off stem, place cut-side down, slice in half through root. Cut off root, remove papery layers.",
      "Slice uniformly from right to left about 1/8 inch thick. When near end, flip on side and continue.",
      "Pack sliced onions loosely in clean jar.",
      "Add aromatics between layers: garlic (smashed), bay leaves, thyme, peppercorns, red pepper flakes, and any chosen seasonings. (If using beets, layer with onions.)",
      "Pour hot brine over onions until completely covered. Leave 1/4 inch headspace.",
      "If onions float, place paper towel on top to keep submerged.",
      "Put on lid. Let sit at room temperature 1 hour, then refrigerate.",
      "Can eat immediately. Flavor improves after 24 hours. Keep refrigerated, lasts 2-3 weeks."
    ],
    "equipment": ["Mason jar", "Saucepan", "Sharp knife", "Cutting board"],
    "tips": [
      "Make two jars: one classic, one experiment",
      "Cut pole-to-pole keeps onions from falling apart",
      "Try different vinegars for different flavors",
      "Adjust sweetness to taste - can omit sugar",
      "Add jalapeños for heat, or try different herbs",
      "Liquid can be reused once for a second batch"
    ],
    "notes": "Pickled red onions are endlessly versatile. They add acidity, crunch, and beautiful color to any dish. The basic brine stays the same - experiment with different spices and additions!"
  }
}
